/* eslint-disable react-hooks/exhaustive-deps */
import { USER_SPECIAL_FIELDS } from 'consts'
import React, { useEffect, useState } from 'react'
import ChangeUserPassword from './change-user-password'
import { deleteUser, getCountriesAndConfig, sendResetPasswordMail, unlinkWatch, unlockUser, updatePatientOrDocAndUser } from 'api/admin-api'
import { useSelector } from 'react-redux'
import Select from 'react-select'
import Physicians from 'pages/physicians/Physicians'
import './admin.scss'

function PatientEdit({data, peripheral}) {

    const { countries, appConfigurations, user: adminUser } = useSelector(state => state)
    const [isEdit, setIsEdit] = useState(false)
    const [isPhysicianEdit, setIsPhysicianEdit] = useState(false)
    const [newData, setNewData] = useState(data)
    const [showFullData, setShowFullData] = useState(false)

    const renderDeviceSection = () => {
        const user = data?.user || {}
        const patient = data?.patient || {}
        const peripheralData = peripheral || {}

        const getFwVersion = () => {
            return peripheralData?.fwVersion 
                || patient.fwVersion 
                || patient.fw_version 
                || '-'
        }

        const getPeripheralName = () => {
            return peripheralData?.name 
                || patient.peripheralName 
                || patient.peripheral_name 
                || '-'
        }

        const getConfiguration = () => {
            const countryObj = countries.find(c => c.code === patient.country)
            const configId = countryObj?.app_configuration_id
            const configName = appConfigurations?.find(c => c.id === configId)?.name
            return configName || '-'
        }

        return (
            <div className='device-info-sections mb-4'>
                <div className='device-section user-info-section'>
                    <h5 className='section-header'>User Info</h5>
                    <div className='section-content'>
                        <div className='info-row'>
                            <span className='info-label'>First Name:</span>
                            <span className='info-value'>{patient.firstName || patient.first_name || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Last Name:</span>
                            <span className='info-value'>{patient.lastName || patient.last_name || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Patient Id:</span>
                            <span className='info-value'>{patient.id || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>User Id:</span>
                            <span className='info-value'>{user.id || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Country:</span>
                            <span className='info-value'>{patient.country || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Configuration:</span>
                            <span className='info-value'>{getConfiguration()}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Email:</span>
                            <span className='info-value'>{user.email || '-'}</span>
                        </div>
                    </div>
                </div>

                <div className='device-section watch-details-section'>
                    <h5 className='section-header'>Watch Details</h5>
                    <div className='section-content'>
                        <div className='info-row'>
                            <span className='info-label'>FW Version:</span>
                            <span className='info-value'>{getFwVersion()}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Peripheral:</span>
                            <span className='info-value'>{getPeripheralName()}</span>
                        </div>
                    </div>
                </div>

                <div className='device-section mobile-device-section'>
                    <h5 className='section-header'>Mobile Device Info</h5>
                    <div className='section-content'>
                        <div className='info-row'>
                            <span className='info-label'>Mobile App Version:</span>
                            <span className='info-value'>{user.mobileAppVersion || user.mobile_app_version || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Device Model:</span>
                            <span className='info-value'>{user.deviceModel || user.device_model || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>Device Manufacturer:</span>
                            <span className='info-value'>{user.deviceManufacturer || user.device_manufacturer || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>OS:</span>
                            <span className='info-value'>{user.os || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>OS Version:</span>
                            <span className='info-value'>{user.osVersion || user.os_version || '-'}</span>
                        </div>
                        <div className='info-row'>
                            <span className='info-label'>OS Release:</span>
                            <span className='info-value'>{user.osRelease || user.os_release || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const fetchData = async () => {
        if(!countries.length) await getCountriesAndConfig()
    }
    
    useEffect(() => {
        fetchData()
    }, [])
    
    useEffect(() => {
        setNewData(data)
    }, [data])

    const handleInput = (e, type) => {
        setNewData(prevData => ({...prevData, [type]:{...prevData[type], [e.target.name]: e.target.value}}))
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        console.log('newData', newData)
        await updatePatientOrDocAndUser(newData)
        setIsEdit(false)
    }

    const cancelEdit = () => {
        setIsEdit(false)
        setNewData(data)
    }

    const getCountriesOptions = () => {
        return countries.map(op => ({value: op.code, label: op.name}))
    }

    const getOrderedOptions = (options) => {
        return options.map(op => ({value: op?.value || `${op}`.toLowerCase(), label: op?.label || op}))
    }

    const renderSelectField = (type, field) => {
        let {options} = USER_SPECIAL_FIELDS[field]
        options = field === 'country' ? getCountriesOptions() : getOrderedOptions(options)
        const selectedOption = options?.find(c => newData?.[type]?.[field] === c.value)
        return (
            <div key={field} className='form-group'>
                <label htmlFor={field}>{USER_SPECIAL_FIELDS[field]?.title || field}: </label>
                <Select
                    key={selectedOption?.value}
                    options={options}
                    isDisabled={!isEdit || USER_SPECIAL_FIELDS[field]?.blockEdit}
                    isClearable={false}
                    defaultValue={selectedOption}
                    onChange={(selectedElements) => {
                        const e = {target: {name: field, value: selectedElements?.value}}
                        handleInput(e, type)
                    }} 
                />
            </div>
        )
    }

    const renderField = (type, field) => {
        if(USER_SPECIAL_FIELDS[field]?.options){
            return renderSelectField(type, field)
        }
        return (
            <div key={field} className='form-group'>
                <label htmlFor={field}>{USER_SPECIAL_FIELDS[field]?.title || field}: </label>
                <input readOnly={!isEdit || USER_SPECIAL_FIELDS[field]?.blockEdit} name={field} value={newData?.[type]?.[field] || ''} onInput={(e) => handleInput(e, type)} className='form-control' id={field} />  
            </div>
        )

    }

    const handleDeleteUser = () => {
        const toDelete = window.confirm('are you shure you want to delete this pateint?')
        if(toDelete) deleteUser(data?.user?.id)
    }

    const handleUnlock = async () => {
        await unlockUser(data?.user?.id, true)
    }

  if(isPhysicianEdit){
    return (
        <>
            <button onClick={() => setIsPhysicianEdit()} className='btn btn-outline-dark mr-2'>
               {'<- Back to patient'}
            </button>
            <Physicians patientId={data?.patient?.id} jwtToken={adminUser?.jwtToken} role={adminUser?.type} />
        </>
    )
  }

  return (
    <div className='patient-edit-wrapper'>
            <div className='patient-actions row mb-3'>
                <button onClick={() => handleDeleteUser()} className='btn btn-danger mr-2'>
                    Delete user
                </button>
                <button onClick={() => setIsEdit(!isEdit)} className='btn btn-success mr-2'>
                    Edit
                </button>
                <button onClick={handleUnlock} className='btn btn-success mr-2'>
                    Unlock user
                </button>
                {data?.patient && 
                    <>
                        <button disabled={!data?.patient?.deviceId} onClick={() => unlinkWatch(data?.patient?.id, true)} className='btn btn-success mr-2'>
                            Unlink watch
                        </button>
                        <button onClick={() => setIsPhysicianEdit(true)} className='btn btn-success mr-2'>
                            Set physicians
                        </button>
                    </>
                }
                <button onClick={() => sendResetPasswordMail(data?.user?.email, true)} className='btn btn-success mr-2'>
                    Send reset password mail
                </button>
               <ChangeUserPassword userId={data?.user?.id}/>
            </div>

            {renderDeviceSection()}

            <div className='full-patient-data-section'>
                <button className='btn btn-link p-0 border-0' onClick={() => setShowFullData(!showFullData)}>
                    {showFullData ? '▼' : '▶'} Full Patient Data
                </button>
                {showFullData && (
                    <div className='full-data-content mt-3'>
                        <form onSubmit={handleSubmit} className='form w-50'>
                            {
                                Object.keys(newData).map(type => 
                                    newData[type] && <div key={type}>
                                        <h2>{type}</h2>
                                        {Object.keys(newData[type])?.map(field => renderField(type, field))}
                                    </div>
                                )
                            }
                            {isEdit && 
                                <div className='edit-patient-form-actions'>
                                    <button disabled={false} type='submit' className='btn btn-primary'>Save Patient</button>
                                    <button onClick={cancelEdit} type='button' className='btn btn-danger'>Cancel</button>
                                </div>
                            }
                        </form>
                    </div>
                )}
            </div>
    </div>
  )
}

export default PatientEdit